var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container-fluid p-0"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_vm._v(" Are you sure you want to cancel this order?"),_c('br'),_vm._v(" This action can not be reversed. ")])])])
}]

export { render, staticRenderFns }